import React from 'react';
import {connect} from 'react-redux';
import {Grid} from '@mui/material';

import {Dispatch, SelectOption} from 'spectra-logic-ui';
import {patchResource} from 'spectra-logic-ui/actions';
import {FormDialog, MultiSelect, TextField} from 'spectra-logic-ui/components';

import {Aggregate, Pool} from '@/types';
import {isCloud} from '@/storage/cloud';

export type FormValues = {
  name: string;
  ids: string[];
}

type Props = {
  aggregate: Aggregate;
  pools: Pool[];
  onSubmit: (values: FormValues) => Promise<any>;
}

const EditAggregateDialog = ({aggregate, pools=[], onSubmit, ...others}: Props) => {
  const {storage, ...othersAggregate} = aggregate;
  const ids = storage.map((s) => s.id);
  const initialValues = {ids, ...othersAggregate};
  const onPremiseStorage = pools.filter((p) => !isCloud(p));
  const storageOptions = onPremiseStorage.map((p) => {
    return {key: p.id, text: `${p.name} (${p.id})`};
  }) as SelectOption[];

  return (
    <FormDialog title='Edit Storage Group' initialValues={initialValues} onSubmit={onSubmit} {...others}>
      {() => (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField name='name' label='Name' />
          </Grid>
          <Grid item xs={12}>
            <MultiSelect name='ids' label='Storage' options={storageOptions} />
          </Grid>
        </Grid>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {aggregate}: Props) => ({
  onSubmit: (values: FormValues) => {
    return dispatch(patchResource('aggregates', aggregate.id, values));
  },
});

export default connect(undefined, mapDispatchToProps)(EditAggregateDialog);
